/**
 * Feature flag constants for type-safe feature flag checks
 * Use these constants with hasFeature() and isFeatureEnabled()
 *
 * @example
 * hasFeature(FEATURE_FLAGS.DOCUMENT_CONTEXT)
 * isFeatureEnabled(features, FEATURE_FLAGS.DOCUMENT_CONTEXT)
 */
export const FEATURE_FLAGS = {
  DOCUMENT_CONTEXT: 'documentContext',
  CONNECTION_RETRY: 'connectionRetry',
  CUSTOM_TEMPLATES: 'customTemplates',
  TRANSCRIPT_EDITING: 'transcriptEditing',
  PLATFORM_TEMPLATE_TABLE: 'platformTemplateTable',
  SCRIBE_BACKGROUND_GENERATION: 'scribeBackgroundGeneration',
  UNIFIED_SESSION_ID: 'unifiedSessionId',
  TELEHEALTH: 'telehealth',
  /** Opt-in for continuous-capture UI (resume confirmation, PAUSED/resume affordances). Requires unifiedSessionId. */
  CONTINUOUS_CAPTURE_UI: 'continuousCaptureUi',
  /** Thumbs rating, reasons and an optional comment on a completed note (SOAP Notes footer). */
  SCRIBE_FEEDBACK: 'scribeFeedback',
} as const;

/**
 * Feature flags controlling widget behavior
 *
 * Feature flags can be set via:
 * 1. Widget initialization context (initialContext.features)
 * 2. Runtime updates via widget context
 */
type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export type FeatureFlags = Partial<Record<FeatureFlagKey, boolean>>;
